export default __webpack_public_path__ + "static/media/NFO_PostLogin_MidSmall_Finacial_Services_Hero_desktop.e6210be2.jpg";